import { ATG_UPDATE } from 'shared/constants/StompKind';
import * as sharedTypes from 'shared/redux/actionTypes';

const defaultState = null;

export default function reducer(state = defaultState, action = {}) {
  if (
    action.type === sharedTypes.STOMP_RECEIVE_DATA &&
    action.payload.kind === ATG_UPDATE
  ) {
    const { atgTopic: topic } = action.meta;

    return {
      topic,
      data: action.payload.data,
    };
  }

  if (action.type === sharedTypes.DELETE_USER) {
    return defaultState;
  }

  return state;
}
